import React from "react";
import { SITE } from "@/lib/site";
import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => {
  const url = `https://wa.me/${SITE.phoneClean}?text=${encodeURIComponent(SITE.whatsappMessage)}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3.5 text-white shadow-lg shadow-[#25D366]/30 transition-transform hover:scale-105 active:scale-95"
    >
      <MessageCircle className="h-5 w-5" strokeWidth={2.2} />
      <span className="hidden sm:inline text-sm font-medium tracking-wide">Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
